import {useState} from 'react';
import TagInput from './TagInput';

// Création ET la modification
export default function NoteForm({initialNote, onSubmit, onCancel, submitLabel = 'Ajouter'}) {
    const [title, setTitle] = useState(initialNote?.title ?? '');
    const [content, setContent] = useState(initialNote?.content ?? '');
    const [tags, setTags] = useState(initialNote?.tags ?? []);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            await onSubmit({title, content, tags});

            if (!initialNote) {
                setTitle('');
                setContent('');
                setTags([]);
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <form className="note-form" onSubmit={handleSubmit}>
            <input
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Titre"
                maxLength={100}
            />
            <textarea
                value={content ?? ''}
                onChange={e => setContent(e.target.value)}
                placeholder="Contenu"
                rows={3}
            />
            <TagInput tags={tags} onChange={setTags}/>

            {error && <p className="error">{error}</p>}

            <div className="row">
                <button type="submit">{submitLabel}</button>
                {onCancel && <button type="button" onClick={onCancel}>Annuler</button>}
            </div>
        </form>
    );
}
